import CollageImg from '../../../assets/FreeTrialLandingPage/Collage.png';
import '@typeform/embed/build/css/popup.css';

function HeroBanner() {
  return (
    <section className='text-center before:block before:absolute before:-inset-1  before:bg-gradient-to-b before:from-highlight-eggshell before:to-white before:h-full before:-z-1 relative'>
      <div className='max-w-6xl mx-auto px-4 sm:px-6'>
        {/* Hero content */}
        <div className='pt-16 md:pt-4 '>
          {/* Section header */}
          <div className=' pb-12 md:pb-16'>
            <h1 className='text-4xl md:text-5xl font-black leading-none mt-8 mb-4 text-text-main'>
              Join Singapore's leading mastermind community for founders today!
            </h1>
            <div className='max-w-4xl mx-auto'>
              <p className='text-xl text-text-main mb-8'>
                Being a founder in Singapore is lonely and difficult. Join a private mastermind community and attend
                monthly teh peng chats, modern networking events, and private masterminds.
              </p>
              <div className='mx-auto max-w-sm sm:max-w-none sm:flex sm:justify-center'>
                <a href='https://szuv34ek50v.typeform.com/to/W2b3Dq1h'>
                  <button>
                    <div className=' bg-primary-main hover:bg-primary-hover text-white py-4 px-4 md:px-10 rounded-full items-center'>
                      <h3 className='text-xl md:text-2xl font-bold'>Claim your 30-day free trial</h3>
                      <p className='text-xs sm:text-sm font-light'>
                        Join a private community of {'>'}100 founders today.
                      </p>
                    </div>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='max-w-7xl mx-auto px-4 sm:px-6'>
        <img className='mx-auto drop-shadow-3xl mb-10' src={CollageImg} alt='Logo' />
      </div>
      <a href='#skills' className='font-bold text-2xl text-link-main hover:text-link-hover underline'>
        See what our members are saying
      </a>
    </section>
  );
}

export default HeroBanner;
